import {PatientSurveyProps} from '../../types';
import {parseJSON} from '../../../../helpers';
import RadioFieldGroup from '../../../common/formik/fields/RadioGroupField';

type OptionRadioFieldProps = {
  data: PatientSurveyProps;
  disabled: boolean;
}

const OptionRadioField = ({data, disabled}: OptionRadioFieldProps) => {
  const {id, label, required, details, answer = ''} = data;
  const {options} = parseJSON(details);

  return (
    <div className="option-field">
      <RadioFieldGroup
        name={`${id}`}
        data={options}
        label={label}
        showLabel
        required={required}
        disabled={disabled}
        defaultValue={answer}
      />
    </div>
  );
};

export default OptionRadioField;
